import { WifiOff } from 'lucide-react';
import { useNetworkStatusContext } from '@/contexts/NetworkStatusContext';
import { T } from '@/lib/tokens';

/**
 *
 */
export function OfflineBanner() {
  const { isOnline } = useNetworkStatusContext();

  if (isOnline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-0 left-0 right-0 z-50 flex items-center justify-center gap-2 px-4 py-3 text-sm font-medium animate-in slide-in-from-bottom-2 duration-300"
      style={{ backgroundColor: T.danger, color: T.white }}
    >
      <WifiOff className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span>You're offline — changes won't save until you reconnect.</span>
    </div>
  );
}
